export const defaultFormValues = {
  subject: "",
  body: "",
};
